import { autoinject } from "aurelia-dependency-injection";
import { type UserSecurityInfoModel } from "../../../../../../models/authentication/token.models";
import { UserClientService } from "../../../../../../services/authentication/user-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { TradeScreeningTemplate } from "../../templates/trade-screening/trade-screening";
import { TradeCheckTemplate } from "../../templates/trade-check/trade-check";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject
export class PrintScreeningReportDialog {
    
    model: TradeScreeningTemplate|TradeCheckTemplate;
    refPrintPageScreeningReport: HTMLElement;
    public generatedOn = new Date();

    constructor(private dialogClientService: DialogClientService, private userClientService: UserClientService) { }

    activate(model: TradeScreeningTemplate | TradeCheckTemplate){
        this.model = model;
    }

    close() {
        this.dialogClientService.hide();
    }

    printDocument() {
        $(".document-screening-report").printThis({
            importCSS: true,
            importStyle: true,
            loadCSS: "/styles/core.min.css",
            canvas: true
        });
    }
      
    get printPageScrollWidth() {
        if(this.refPrintPageScreeningReport) {
            return this.refPrintPageScreeningReport.scrollWidth - 20;
        }
    }
    
    @computedFrom(Reflection.getPropertyPath<PrintScreeningReportDialog>(z => z.userClientService.currentUser))
    public get user(): UserSecurityInfoModel {
        return this.userClientService.currentUser;
    }
}
